import { Navigate, useParams } from 'react-router';
import { ErrorBoundary } from '../components/ui';
import { PayRunDetailScreen } from '../features/payRuns/PayRunDetailScreen';

export const PayRunDetailPage = () => {
  const { payId } = useParams();
  if (!payId) return <Navigate to="/payroll/pay-runs" replace />;

  return (
    <ErrorBoundary
      title="Pay Run details unavailable"
      message="This Pay Run could not be displayed. Retrying reloads it from scratch."
    >
      <PayRunDetailScreen payId={payId} showHeaderAndLifecycle={false} />
    </ErrorBoundary>
  );
};
